<script>
import { mapGetters } from 'vuex';
import Spinner from 'dashboard/components-next/spinner/Spinner.vue';

export default {
  components: {
    Spinner,
  },
  props: {
    emptyStateMessage: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'notifications/getUIFlags',
    }),
    emptyMessage() {
      if (this.emptyStateMessage) {
        return this.emptyStateMessage;
      }
      return this.$t('INBOX.LIST.NOTE');
    },
  },
};
</script>

<template>
  <div
    class="items-center justify-center hidden w-full h-full text-center bg-n-surface-1 lg:flex"
  >
    <div v-if="uiFlags.isFetching" class="flex justify-center my-4">
      <Spinner class="text-n-brand" />
    </div>
    <div
      v-else
      class="flex flex-col items-center gap-4 px-6 py-8 rounded-2xl border border-n-alpha-3 bg-n-slate-2/40 shadow-sm"
    >
      <div
        class="grid place-content-center size-16 rounded-2xl bg-n-alpha-2 border border-n-alpha-3"
      >
        <fluent-icon icon="mail-inbox" size="28" class="text-n-slate-11" />
      </div>
      <div class="flex flex-col gap-1">
        <span class="text-base font-semibold text-n-slate-12">
          {{ $t('INBOX.LIST.NO_MESSAGES_AVAILABLE') }}
        </span>
        <span class="text-sm text-n-slate-11 max-w-sm">
          {{ emptyMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

